import { render, staticRenderFns } from "./TableCustomerCategory.vue?vue&type=template&id=05ac9bdd"
import script from "./TableCustomerCategory.vue?vue&type=script&lang=js"
export * from "./TableCustomerCategory.vue?vue&type=script&lang=js"
import style0 from "./TableCustomerCategory.vue?vue&type=style&index=0&id=05ac9bdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports